import React from 'react';
import styled from 'styled-components';
import { FaSearch } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { StripeProduct } from '../context/stripe_products_context';

interface StripeProductProps {
  product: StripeProduct;
}

const StripeProductComponent: React.FC<StripeProductProps> = ({ product }) => {
  const { images, name, description, default_price, prices } = product;
  const image = images && images.length > 0 ? images[0] : '/placeholder-image.jpg';
  
  // Format price from cents to dollars
  const formatPrice = (amount: number, currency: string = 'usd') => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency.toUpperCase(),
    }).format(amount / 100);
  };

  // Get the default price or first available price
  const displayPrice = default_price || (prices && prices.length > 0 ? prices[0] : null);

  return (
    <Wrapper>
      <div className='container'>
        <Link to={`/stripe-products/${product.id}`}>
          <img src={image} alt={name} />
          <div className='link'>
            <FaSearch />
          </div>
        </Link>
      </div>
      <footer>
        <h5>{name}</h5>
        {displayPrice && (
          <p>{formatPrice(displayPrice.unit_amount, displayPrice.currency)}</p>
        )}
        {description && (
          <p className='description'>{description.substring(0, 100)}...</p>
        )}
        {prices && prices.length > 1 && (
          <p className='price-variants'>{prices.length} price variants available</p>
        )}
      </footer>
    </Wrapper>
  );
};

const Wrapper = styled.article`
  .container {
    position: relative;
    background: var(--clr-black);
    border-radius: var(--radius);
  }
  img {
    width: 100%;
    display: block;
    object-fit: cover;
    border-radius: var(--radius);
    transition: var(--transition);
  }
  .link {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: var(--clr-primary-5);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    transition: var(--transition);
    opacity: 0;
    cursor: pointer;
    svg {
      font-size: 1.25rem;
      color: var(--clr-white);
    }
  }
  .container:hover img {
    opacity: 0.5;
  }
  .container:hover .link {
    opacity: 1;
  }
  footer {
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  footer h5,
  footer p {
    margin-bottom: 0;
    font-weight: 400;
  }
  footer p {
    color: var(--clr-primary-5);
    letter-spacing: var(--spacing);
  }
  .description {
    font-size: 0.875rem;
    color: var(--clr-grey-5);
    margin-top: 0.5rem;
  }
  .price-variants {
    font-size: 0.75rem;
    color: var(--clr-grey-4);
    font-style: italic;
  }
`;

export default StripeProductComponent; 